import { toCamelCaseDeep } from 'src/utils/transform';
import MemriseApi from 'src/api/MemriseApi';
import * as Schema from './schema';

class DashboardApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/dashboard' });
  }

  public async getAllCourses(): Promise<Schema.AllCoursesResponse> {
    const response = await this.get(`/`);
    return toCamelCaseDeep(response);
  }
}

export const DashboardApi = new DashboardApiClass();
